import services from './../../services/service'; // Service Class
import Preset from './../../resources/preset.js'; //Preset Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
import ChatRoom from './../../components/templates/chat/index.vue'; //Your Chat

let service = new services();

export default {
    name: 'Chat',
    mixins: [Preset],
    data () {
        return {
            menu_view:{},
            menu_tab_view:{},
            menu_tab_inner_view:{},
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'component-chatroom': ChatRoom,
        // 'component-postsco': PostsCo
     },
    methods: {
        setMenuTabView(view,attr1,attr2){
            this.menu_tab_inner_view = {};
            this.menu_tab_view = {};
            this.menu_tab_view[view] = true;
        },
       
    },

    created: function(){},
}


// WEBPACK FOOTER //
// ./src/pages/Chats/script.js